// src/components/common/EmptyState.jsx
import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import InboxIcon from '@mui/icons-material/Inbox';

/**
 * EmptyState - Consistent empty/no-data state component
 * Displays a message when no data is available
 *
 * @component
 * @example
 * <EmptyState
 *   title="No Data Available"
 *   message="This employee has no recorded performance data"
 * />
 */
const EmptyState = ({
  title = 'No Data Available',
  message,
  icon: CustomIcon
}) => {
  const Icon = CustomIcon || InboxIcon;

  return (
    <Box
      sx={{
        p: 4,
        textAlign: 'center',
        color: 'text.secondary',
        bgcolor: 'background.paper',
        borderRadius: 1
      }}
    >
      <Icon sx={{ fontSize: '3rem', mb: 2, opacity: 0.5 }} />
      <Typography variant="h6" sx={{ mb: 1 }}>
        {title}
      </Typography>
      {message && (
        <Typography variant="body2" color="text.secondary">
          {message}
        </Typography>
      )}
    </Box>
  );
};

EmptyState.propTypes = {
  /** Title for empty state */
  title: PropTypes.string,
  /** Optional message providing more context */
  message: PropTypes.string,
  /** Optional custom icon component */
  icon: PropTypes.elementType
};

export default EmptyState;
